import React from "react";
import { useData } from "../../../components/firebase/DataProvider";
import { findOnePromo } from "../../../utils/promo";
import {
  arrayToCurrencyString,
  arrayToCurrencyStringPromo,
  arrayToCurrencyStringKomisi,
  calculateHargaLevel,
} from "../../../utils/currency";
import { analytics } from "../../../components/firebase/FirebaseProvider";
import { useHistory } from "react-router-dom";
import slugify from "slugify";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import Button from "@material-ui/core/Button";
import useStyles from "./style/flashSaleStyle";
import { upperFirst } from "lodash";
import { DialogTitle, IconButton } from "@material-ui/core";

function DialogNewProduk({ open, handleClose, data, mode }) {
  const classes = useStyles();
  const history = useHistory();
  const { level, promo, global_komisi } = useData();

  const toDetailProduct = (id, title) => () => {
    // console.log("to detail...");
    analytics.logEvent("view_product", { name: title, id: id });

    history.push(`/produk/${slugify(title.toLowerCase())}/${id}`);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen
      PaperProps={{
        style: { maxWidth: 960 },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            onClick={handleClose}
            style={{ marginRight: 15 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography>{mode}</Typography>
        </div>
      </DialogTitle>{" "}
      <DialogContent dividers style={{ padding: 10 }}>
        <Grid container className={classes.rootDialog} spacing={3}>
          {data
            .sort((a, b) => {
              const stok_a = a?.variants?.map(
                (variant) => variant.stok_available
              );
              const total_stok_a = stok_a?.reduce((val, nilaiSekarang) => {
                return val + nilaiSekarang;
              }, 0);
              const stok_b = b?.variants?.map(
                (variant) => variant?.stok_available
              );
              const total_stok_b = stok_b?.reduce((val, nilaiSekarang) => {
                return val + nilaiSekarang;
              }, 0);
              return total_stok_b - total_stok_a;
            })
            .map((item, index) => {
              const stok = item?.variants.map(
                (variant) => variant?.stok_available
              );

              const productValue =
                item?.product_value !== undefined &&
                item?.product_value !== "" &&
                !Number.isNaN(item?.product_value) &&
                item?.product_value >= 0
                  ? item?.product_value
                  : 1;

              const harga = item?.variants?.map((variant) =>
                calculateHargaLevel(
                  variant?.harga_normal,
                  global_komisi,
                  level?.level,
                  productValue
                )
              );

              const harga_normal = item?.variants?.map(
                (variant) => variant?.harga_normal
              );

              const promoFound = findOnePromo(item, promo);

              const total_stok = stok?.reduce((val, nilaiSekarang) => {
                return val + nilaiSekarang;
              }, 0);

              const emptyStock = total_stok === 0 ? true : false;

              const harga_str = arrayToCurrencyString(harga);
              const promoF = promoFound ? true : false;

              const harga_str_promo =
                promoFound &&
                arrayToCurrencyStringPromo(
                  harga_normal,
                  promoFound,
                  level.level,
                  global_komisi,
                  productValue
                );

              const textBadgePromo = (() => {
                let text = "";

                if (promoFound) {
                  if (promoFound?.tipe === "%") {
                    text = `${promoFound?.nilai}%`;
                  } else {
                    text = `${promoFound?.nilai / 1000}K`;
                  }
                }

                return text;
              })();

              const lowestPrice = Math.round(Math.min(...harga_normal));

              const all_komisi_str = arrayToCurrencyStringKomisi(
                lowestPrice,
                level.level,
                promoFound,
                global_komisi,
                productValue
              );

              return (
                <div className={classes.wrapper} key={index}>
                  <Card className={classes.card}>
                    <CardActionArea
                      onClick={toDetailProduct(item.id, item.nama)}
                    >
                      {promoF && !emptyStock ? (
                        <div className={classes.label}>
                          <Typography className={classes.txtLabel}>
                            {textBadgePromo}
                          </Typography>
                          <Typography className={classes.txtLabel}>
                            OFF
                          </Typography>
                        </div>
                      ) : null}
                      {emptyStock ? (
                        <div className={classes.empty}>
                          <span className={classes.txtEmpty}>Stok Habis</span>
                        </div>
                      ) : null}
                      {item.thumbnail?.length > 0 ? (
                        <div
                          loading="lazy"
                          // src={item.thumbnail[0]}
                          // alt={item.id}
                          className={classes.img}
                          style={{
                            backgroundImage: `url(${item?.thumbnail?.[0]})`,
                          }}
                        />
                      ) : (
                        <div
                          loading="lazy"
                          // src={item.thumbnail}
                          // alt={item.id}
                          className={classes.img}
                          style={{
                            backgroundImage: `url(${item?.thumbnail?.[0]})`,
                          }}
                        />
                      )}
                    </CardActionArea>
                    <div className={classes.contentWrapper}>
                      <div className={classes.content}>
                        <div style={{ display: "flex" }}>
                          {promoFound?.flash_sale ||
                          promoFound?.special_offer ? (
                            <div className={classes.labelFlash}>
                              {promoFound?.flash_sale
                                ? "Flashsale"
                                : "Special Offer"}
                            </div>
                          ) : null}
                          {item?.properties?.type === "preorder" &&
                          item?.properties.end_at?.seconds * 1000 >
                            Date.now() ? (
                            <div className={classes.labelPre}>Pre Order</div>
                          ) : null}
                          {item?.campaigns ? (
                            <div className={classes.labelNew}>Campaigns</div>
                          ) : (
                            <div className={classes.labelNew}>Baru</div>
                          )}
                        </div>{" "}
                        <Typography className={classes.title} component="p">
                          {item?.nama}
                        </Typography>
                        {item?.properties?.type === "preorder" ? (
                          ""
                        ) : (
                          <>
                            <Typography
                              className={classes.txtStockTersedia}
                              component="p"
                            >
                              Stok tersedia
                            </Typography>
                            <Typography
                              className={classes.txtStock}
                              component="p"
                            >
                              {total_stok > 100 ? "99+" : total_stok} pcs
                            </Typography>
                          </>
                        )}
                        <Typography
                          className={classes.txtLabelharhag}
                          component="p"
                        >
                          Harga {upperFirst(level.level)}
                        </Typography>
                        <Typography className={classes.price} component="p">
                          {promoFound ? harga_str_promo : harga_str}
                        </Typography>
                        <div className={classes.labelKomisi}>
                          {all_komisi_str} Komisi
                        </div>
                        {/* <div
                          style={{
                            position: "absolute",
                            right: 5,
                            zIndex: "0",
                          }}
                        >
                          <NewFeatureIcon width={32} height={32} />
                        </div> */}
                      </div>
                      <div className={classes.btnWrap}>
                        {emptyStock ? (
                          <Button
                            fullWidth
                            variant="contained"
                            color="secondary"
                            size="small"
                            className={classes.btn}
                            style={{
                              backgroundColor: "rgb(255, 107, 107)",
                            }}
                          >
                            Stok Habis
                          </Button>
                        ) : (
                          <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            size="small"
                            className={classes.btn}
                            onClick={toDetailProduct(item?.id, item?.nama)}
                          >
                            Beli
                          </Button>
                        )}
                      </div>
                    </div>
                  </Card>
                </div>
              );
            })}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default DialogNewProduk;
